import type { ReactNode } from 'react';
import type { HeadingLevel } from '@/lib/utils/headingLevel';

type VehicleEmptyStateProps = {
    headingLevel: HeadingLevel;
    /** Without it the stock itself is empty — nothing to reset. */
    onReset?: () => void;
    /** The editor's way out, e.g. „Kontakt aufnehmen“ — rendered on the server. */
    action?: ReactNode;
};

export function VehicleEmptyState({ headingLevel, onReset, action }: VehicleEmptyStateProps) {
    const Heading = `h${headingLevel}` as const;

    return (
        <div className="vehicle-empty">
            <Heading className="heading-1">Keine Fahrzeuge gefunden</Heading>
            <p className="vehicle-empty__text text-md">
                {onReset
                    ? 'Für die gewählten Filter haben wir aktuell kein passendes Fahrzeug im Bestand. Wir finden gerne eines für Sie.'
                    : 'Aktuell ist kein Fahrzeug im Bestand. Wir finden gerne eines für Sie.'}
            </p>

            <div className="vehicle-empty__actions">
                {onReset ? (
                    <button type="button" className="btn btn-primary" onClick={onReset}>
                        Filter zurücksetzen
                    </button>
                ) : null}
                {action}
            </div>
        </div>
    );
}
